import React from 'react';
import PropTypes from 'prop-types';
import Bg from "../../assets/interview/interview-theme/images/bg-abstract.svg";
import serverError from "../../assets/interview/interview-theme/images/server-error.webp";
function Error500({ error }) {
  return (
    <>
      <section className="py-5 d-flex align-items-center justify-content-center h-100" style={{ background: `url(${Bg}) no-repeat center / 100%` }}>
          <div className="container">
              <div className="row">
                  <div className="col-lg-8 col-xl-7 col-xxl-6 mx-auto text-center">
                      <figure className="mx-auto mb-4" style={{ maxWidth: 460 }}>
                          <img  src ={serverError} alt="Server error" className="img-fluid" />
                      </figure>
                      <h1 className="h2 mb-3">Internal Server Error</h1>
                      <p className="mb-2 text-muted">We're experiencing an internal server error.</p>
                      <p className="text-muted">Please try again later.</p>
                  </div>
              </div>
          </div>
      </section>
    </>
  );
}

Error500.propTypes = {
  error: PropTypes.number,
};

Error500.defaultProps = {
  error: 0,
};

export default Error500;
